
import {Component, Mixins} from 'vue-property-decorator';
import PazLoader from '@pazion/pazion-core/src/components/utils/PazLoader.vue';
import {
  IDocumentsForCategory,
  IDossierFile
} from "@pazion/pazion-core/src/models/dossier.model";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import FileTab from "@pazion/pazion-core/src/views/dossier/parts/FileTab.vue";
import DossierRequiredDocumentCategory
  from "@pazion/pazion-core/src/views/dossier/parts/DossierRequiredDocumentCategory.vue";
import PazInputConfirmTextField from "@pazion/pazion-core/src/components/input/PazInputConfirmTextField.vue";
import EditDossierUsers from "@pazion/pazion-core/src/components/dialog/parts/EditDossierUsers.vue";
import DossierProperties from "@pazion/pazion-core/src/views/dossier/parts/DossierProperties.vue";
import DossierRequiredDocument from "@pazion/pazion-core/src/views/dossier/parts/DossierRequiredDocument.vue";
import {
  fetchExtraDossierInfo,
  getDossierFilesById,
  modifyDossierUser
} from "@pazion/pazion-core/src/services/dossier-service";
import UserMemberOfList from "@pazion/pazion-core/src/views/user/UserMemberOfList.vue";
import AuthUsermixin from "@pazion/pazion-core/src/mixins/AuthUser.mixin";

@Component({
  components: {
    UserMemberOfList,
    DossierRequiredDocumentCategory,
    FileTab,
    PazInputConfirmTextField,
    DossierProperties,
    EditDossierUsers,
    PazLoader,
    PazTooltipButton,
    DossierRequiredDocument
  },
})
export default class DossierViewWithRequiredCategories extends Mixins(AuthUsermixin) {

  public files: IDossierFile[] = [];

  public tab: any = null;
  private loading: boolean = true;
  private filesLoading: boolean = true;
  private dossierId: number = 0;
  private userCount: number = 0;
  private name: string = '';
  private nameOrg: string = '';
  private isClosed: boolean = false;
  private details: object = {};
  private dossierDetails: object[] = [];
  private requiredDocuments: IDocumentsForCategory[] = [];

  created() {
    this.dossierId = parseInt(this.$route.params.id);
  }

  mounted() {
    this.fetchData();
    this.fetchFileData();

  }

  async reloadFiles() {
    await this.fetchFileData();
  }

  async fetchFileData() {
    this.filesLoading = true;
    const files = await getDossierFilesById(this.dossierId);
    this.files = files.files;
    this.filesLoading = false;
  }

  async reloadData() {
    await this.fetchData();
  }

  async fetchData() {
    this.loading = true;
    const rsp = await fetchExtraDossierInfo(this.dossierId);
    this.name = rsp.dossier.name;
    this.nameOrg = rsp.dossier.name;
    this.isClosed = rsp.dossier.status == 1;
    this.userCount = rsp.users.length;
    this.details = rsp.dossier;
    this.dossierDetails = rsp.details;
    this.requiredDocuments = rsp.requiredFiles;
    this.loading = false;
  }

  async addUser(id: number, callback: (success: boolean) => void): Promise<boolean> {
    if (this.dossierId < 1) {
      return false;
    }
    let rsp = await modifyDossierUser(this.dossierId, id, 'add');
    callback(rsp.success === true);
    return true;
  }

  async removeUser(id: number, callback: (success: boolean) => void): Promise<boolean> {
    if (this.dossierId < 1) {
      return false;
    }
    let rsp = await modifyDossierUser(this.dossierId, id, 'remove');

    callback(rsp.success === true);
    return true;
  }

}
